import theme from '../../../theme';

const ArrowDropUp = ({ width, height, color, ...props }) => (
  <svg
    width={width || '24'}
    height={height || '25'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 14L12 9L17 14H7Z"
      fill={color || theme.color.black}
      fill-opacity="0.54"
    />
  </svg>
);

export default ArrowDropUp;
